module.exports = __webpack_public_path__ + "img/ooh_dark.e0b27f1c.png";